import { useState, useEffect } from "react";
import CompanySelect from "../../components/CompanySelect";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Swal from "sweetalert2";
import { userRequest } from "../../requestMethods";
import Loading from "../../components/loading/loading";
import { formatTimeDDMMYYY } from "../../util/helper";
import CustomGrid from "../../components/grid/CustomGrid";

export default function IntegrationError() {
  const [companyId, setCompanyId] = useState();
  const [id, setId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    gtLogs();
  }, [companyId]);
  const gtLogs = async () => {
    setIsLoading(true);
    try {
      const res = await userRequest.get(`${companyId}/integration/logs`);

      setData(
        res.data.map((item) => ({
          integrationId: item.logId,
          integration: item.integration,
          json: JSON.stringify(item.json),
          rtJson: JSON.stringify(item.rtJson),
          createdAt: item.createdAt,
        })),
      );
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      field: "integration",
      headerName: "Integração",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "json",
      headerName: "Recebido",
      width: 400,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "rtJson",
      headerName: "Recebido",
      width: 600,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "createdAt",
      headerName: "Criada em",
      width: 200,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      valueFormatter: (value) => {
        if (value === null) {
          return "";
        }
        return `${formatTimeDDMMYYY(value)}`;
      },
      valueGetter: (value) => value && new Date(value),
    },
  ];
  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="div_custom_Container">
            <CompanySelect onSelect={(companyId) => setCompanyId(companyId)} />
          </div>
          <div className="div_custom_UpdateLeft">
            <CustomGrid
              gridId="integrationError"
              getRowId={(row) => row.integrationId}
              rows={data}
              columns={columns}
              tableHeight="900px"
            />
          </div>
        </>
      )}
    </div>
  );
}
